import Base from './Base';
import Case from './Case';

export const mapOrderField = (field) => {
  const mapping = {
    description: 'resource.description',
    patientName: 'owner.name',
    status: 'case.status',
    visitDate: 'resource.visitDate',
  };

  return mapping[field] || field;
};

export default class PatientRecord extends Base {
  owner = null;
  caseResource = null;
  case = null;
  id = null;
  description = '';
  imageCount = 0;
  hasTextReport = false;
  createdAt = null;
  visitDate = null;
  deleted = false;
  shareLink = null;
  viewerLink = null;

  constructor(source) {
    super();
    this.clone(source);
    this.visitDate = this.createdAt ? new Date(this.createdAt) : null;
    this.createdAt = this.createdAt ? new Date(this.createdAt) : null;
    this.case = this.case ? new Case(this.case) : null;
    // MED-546: shareLink will share video report, not study
    this.shareLink = this.deleted || !this.status || this.status === 'in-progress' ? null : { id: this.id, viewerLink: this.viewerLink };
  }

  get patientName() {
    return this.owner?.name;
  }

  get status() {
    if (!this.case) {
      return null;
    }
    if (this.case?.status?.value === 'completed') {
      return 'completed';
    }

    if (this.case?.status?.value === 'not-paid') {
      return 'not-paid';
    }

    return 'in-progress';
  }

  get mustBeSelected() {
    return this.case && this.case?.status?.value !== 'completed';
  }
}
